import * as d3 from "d3";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { XAxis } from "../chart/XAxis";
import { YAxis } from "../chart/YAxis";

import "./PhoneHeartRate.css";

function PhoneHRVSmall({ stress, forecast }) {
  const width = 300;
  const height = 70;
  const [marginLeft, marginRight, marginTop, marginBottom] = [20, 15, 15, 5];
  const innerWidth = width - marginLeft - marginRight;
  const innerHeight = height - marginTop - marginBottom;

  stress.forEach((x) => (x.timepoint = new Date(x.timepoint)));
  forecast.forEach((x) => (x.timepoint = new Date(x.timepoint)));

  let minDay = stress[0].timepoint;
  let maxDay = forecast[forecast.length - 1].timepoint;

  for (let row of stress) {
    if (row.timepoint < minDay) {
      minDay = row.timepoint;
    }
    if (row.timepoint > maxDay) {
      maxDay = row.timepoint;
    }
  }
  for (let row of forecast) {
    if (row.timepoint < minDay) {
      minDay = row.timepoint;
    }
    if (row.timepoint > maxDay) {
      maxDay = row.timepoint;
    }
  }

  const xScale = useMemo(() => {
    return d3
      .scaleTime()
      .domain([minDay, maxDay])
      .range([marginLeft, marginLeft + innerWidth])
      .nice();
  }, [innerWidth, marginLeft, maxDay, minDay]);

  const yScale = useMemo(() => {
    const min = Math.max(
      0,
      d3.min([...stress, ...forecast], (d) => d.rmssd) - 10
    );
    const max = d3.max([...stress, ...forecast], (d) => d.rmssd);
    return d3
      .scaleLinear()
      .domain([min, max])
      .range([innerHeight + marginBottom, marginBottom])
      .nice();
  }, [stress, innerHeight, marginBottom]);

  const color = stress.map((x) => {
    if (
      x.stress_index === null ||
      x.stress_index === undefined ||
      x.color === undefined ||
      x.color === null
    ) {
      return "#939393";
    }

    if (x.color === "green") {
      return "#5AD876"; //green
    } else if (x.color === "yellow") {
      return "#E8D286"; //yellow
    } else if (x.color === "red") {
      return "#E88686"; //red
    } else {
      return "#9a9a9a";
    }
  });

  const barWidth = 5;
  return (
    <>
      {stress && (
        <div className="heartRate_chart">
          <div className="heartRate_chart__Chart">
            <svg className="Sparkline hrv" viewBox={`0 0 ${width} ${height}`}>
              <g>
                {forecast.map((d, i) => (
                  <rect
                    x={xScale(d.timepoint)}
                    value={d.timepoint}
                    y={yScale(d.rmssd)}
                    height={innerHeight - yScale(d.rmssd) + marginBottom}
                    width={barWidth}
                    key={`rect-${d.timepoint}-${i}`}
                    className={d.timepoint}
                    fill={color[i]}
                    fillOpacity={0.3}
                  ></rect>
                ))}
                {forecast.map((d, i) => (
                  <rect
                    x={xScale(d.timepoint)}
                    value={d.timepoint}
                    y={yScale(d.rmssd)}
                    height={Math.min(
                      innerHeight - yScale(d.rmssd) + marginBottom,
                      4
                    )}
                    width={barWidth}
                    key={`rect-${d.timepoint}-${i}`}
                    className={d.timepoint}
                    fill={color[i]}
                  ></rect>
                ))}

                {stress.map((d, i) => (
                  <rect
                    x={xScale(d.timepoint)}
                    value={d.timepoint}
                    y={yScale(d.rmssd)}
                    height={innerHeight - yScale(d.rmssd) + marginBottom}
                    width={barWidth}
                    key={`rect-${d.timepoint}-${i}`}
                    className={d.timepoint}
                    fill={color[i]}
                  ></rect>
                ))}
              </g>
              <XAxis
                xScale={xScale}
                innerHeight={innerHeight + marginBottom}
                ticks={10}
              ></XAxis>
              <YAxis yScale={yScale} margin={marginLeft} ticks={4}></YAxis>
            </svg>
          </div>
        </div>
      )}
    </>
  );
}

export default observer(PhoneHRVSmall);
